import { render, staticRenderFns } from "./alert-box.vue?vue&type=template&id=cc112e82&scoped=true&"
import script from "./alert-box.vue?vue&type=script&lang=ts&"
export * from "./alert-box.vue?vue&type=script&lang=ts&"
import style0 from "./alert-box.vue?vue&type=style&index=0&id=cc112e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc112e82",
  null
  
)

export default component.exports